import React from 'react';

import { ToggleButton } from '@mui/material';
import { useEditMode, useNavigationBarMode } from '@wp-block-builder/editor/hooks';

import { NavigationTreeOutlined } from '@waypoint/react/icons';

export default function NavigationTreeButton() {
  const [editMode] = useEditMode();
  const [navigationBarMode, setNavigationBarMode] = useNavigationBarMode();

  const onNavigationBarModeChange = (ev: React.MouseEvent) => {
    ev.stopPropagation();
    const value = navigationBarMode === 'VISIBLE' ? 'HIDDEN' : 'VISIBLE';
    setNavigationBarMode(value);
  };

  return (
    <ToggleButton
      size="small"
      disabled={editMode === 'PREVIEW'}
      value={navigationBarMode}
      selected={navigationBarMode === 'VISIBLE'}
      onClick={onNavigationBarModeChange}
      sx={{ gap: 1, color: 'text.primary' }}
    >
      <NavigationTreeOutlined fontSize="small" />
      <span>Navigator</span>
    </ToggleButton>
  );
}
